import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CustomCookieService } from '@uc/shared/authentication';
import { EntitiesPipe } from '@uc/utilities';
import { CourseGTMService, ImpressionDirective } from '@uc/web/core';
import { Product } from '@uc/web/shared/data-models';
import { SubjectKeyword } from '../../models/course-search.models';

@Component({
	selector: 'uc-featured-course',
	templateUrl: './featured-course.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [EntitiesPipe, ImpressionDirective],
})
export class FeaturedCourseComponent {
	uni = input.required<SubjectKeyword>();
	product = input.required<Product>();

	userAuthenticated = this._customCookieSrv.get('token') ? true : false;

	constructor(
		private _customCookieSrv: CustomCookieService,
		private _courseGTMSrv: CourseGTMService,
	) {}

	// GTM Event
	onKeywordClick() {
		this._courseGTMSrv.keywordClick(
			'Keyword',
			this.uni().university.id,
			this.uni().university.name,
			this.userAuthenticated,
			this.uni().subject,
			this.product(),
		);
	}

	onKeywordImpression(impression: boolean) {
		if (impression) {
			this._courseGTMSrv.keywordImpression(
				'Keyword',
				this.uni().university.id,
				this.uni().university.name,
				this.userAuthenticated,
				this.uni().subject,
				this.product(),
			);
		}
	}
}
